export function initials(user) {
  if (!user) return "?";
  const a = (user.first_name || "").trim();
  const b = (user.last_name || "").trim();
  const two = `${a[0] || ""}${b[0] || ""}`.toUpperCase();
  return two || (a[0] || b[0] || "?").toUpperCase();
}

export default function UserAvatar({ user, size = 40, className = "", testid }) {
  const style = { width: size, height: size };
  if (user?.photo) {
    return (
      <img
        src={user.photo}
        alt=""
        data-testid={testid}
        className={`rounded-full object-cover ${className}`}
        style={style}
      />
    );
  }
  return (
    <div
      data-testid={testid}
      className={`flex items-center justify-center rounded-full bg-cyan font-display font-700 text-void ${className}`}
      style={{ ...style, fontSize: Math.round(size * 0.38) }}
    >
      {initials(user)}
    </div>
  );
}
